export enum LoginMethod {
  QrCode = 1,
  Identifier = 2,
}
